import { createTypes } from 'redux-recompose';

export const actions = createTypes(['APPLY_FILTERS'], '@@PML');

const actionCreators = {
    APPLY_FILTERS: (response) => ({ type: actions.APPLY_FILTERS, notification: response }),
};

export default actionCreators;